import { render, staticRenderFns } from "./modal-widget.vue?vue&type=template&id=30a1c088"
import script from "./modal-widget.vue?vue&type=script&lang=js"
export * from "./modal-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports